import { render, staticRenderFns } from "./AuthCallback.vue?vue&type=template&id=b25fe2c6&scoped=true"
import script from "./AuthCallback.vue?vue&type=script&lang=js"
export * from "./AuthCallback.vue?vue&type=script&lang=js"
import style0 from "./AuthCallback.vue?vue&type=style&index=0&id=b25fe2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25fe2c6",
  null
  
)

export default component.exports